/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCurrencyRupee = createReactComponent("currency-rupee", "IconCurrencyRupee", [
  ["path", { d: "M18 5h-11h3a4 4 0 0 1 0 8h-3l6 6", key: "svg-0" }],
  ["path", { d: "M7 9l11 0", key: "svg-1" }]
]);

export { IconCurrencyRupee as default };
//# sourceMappingURL=IconCurrencyRupee.js.map
